/**
 * Snap an hour count to the nearest half hour, floored at 1.
 *
 * Shared by the api-server booking routes (`snapHoursToHalf`) and the web
 * BookingWidget (`quantizeHours`), which previously each carried their own copy
 * of the `Math.max(Math.round(n * 2) / 2, 1)` rounding rule. Chauffeur / event
 * bookings bill in fractional hours, so the half-hour snap must stay identical
 * on both client and server.
 *
 * `value` may be a number or a numeric string. When it is not a finite
 * positive number, `fallback` is used as the base before rounding.
 */
export function snapHoursToHalf(value: unknown, fallback = 8): number {
  const n = typeof value === "number" ? value : parseFloat(String(value ?? ""));
  const base = Number.isFinite(n) && n > 0 ? n : fallback;
  return Math.max(Math.round(base * 2) / 2, 1);
}
